//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System Block Instances.  NOTE: Some of these are referenced in Migrations to avoid string-typos. */
export const Block = {
    /** The bio block */
    Bio: "B5C1FDB6-0224-43E4-8E26-6B2EAF86253A",
    /** The Campus Detail page Campus Detail block guid */
    CampusDetailCampusDetail: "176FFC6F-6B55-4319-A781-A2F7F1F85F24",
    /** The Campus Detail &gt; Group Member Detail page Group Member Detail block guid */
    CampusDetailGroupMemberDetail: "96361229-3CF1-4713-84B5-E913AECDC804",
    /** The Campus Detail page Group Member List block guid */
    CampusDetailGroupMemberList: "318B80EE-7349-4BF4-82F2-64FC38A5AB0B",
    /** The checkin manager en route */
    CheckinManagerEnRoute: "5F2403E2-1016-4914-8566-3369F3CB74E3",
    /** The checkin manager navigation block guid */
    CheckinManagerNavigation: "B569F42E-6687-45C4-90A4-CC7D99427372",
    /** The checkin manager person recent attendances block guid */
    CheckinManagerPersonRecentAttendances: "087749E0-3C35-4093-980A-483D8D4C3142",
    /** The connection requests bulk update block */
    ConnectionRequestsBulkUpdate: "86249F40-DAA9-46AC-901B-7460E2659C10",
    /** The dataview search results block type */
    DataviewSearchResults: "F1AADFDD-7F43-4B31-A0FD-318064F4C9CC",
    /** The External site Workflow Entry block. */
    ExternalWorkflowEntry: "88B901B3-4DA5-4302-A638-5EF447D5792F",
    /** The financial account search block */
    FinancialAccountSearch: "21B7618B-47DD-4936-ABB5-81BDB4D56C6A",
    /** The Fundraising Transaction Entry block. */
    FundraisingTransactionEntry: "1BAD904E-2F79-4488-B8BE-EECD67AE2925",
    /** The log viewer */
    LogViewer: "BDEF9AA0-55FC-4A66-8938-2AB2E075521B",
    /** The oidc authorize block instance. */
    OidcAuthorize: "7751BBAD-FEF3-4128-AA76-21ABE5388612",
    /** The oidc claims block instance. */
    OidcClaims: "1081CD35-AE21-4ED1-BA9C-3BEA0C3DE7F2",
    /** The oidc client detail block instance. */
    OidcClientDetail: "19B3433E-4C40-44D3-9974-5B2373F8AF8A",
    /** The oidc clients block instance. */
    OidcClientList: "39EB743B-8D75-4873-B613-D71A94B2E48D",
    /** The oidc logout block instance. */
    OidcLogout: "27315B8B-084A-496D-A4F5-125993C71616",
    /** The oidc scope detail block instance. */
    OidcScopeDetail: "C048B2F4-7BB1-4ADA-9C91-B2F6062C05C4",
    /** The oidc scope list block instance. */
    OidcScopeList: "47AA56D8-D8F7-4747-BD11-EBAC536E5888",
    /** The phone number lookup block instance. */
    PhoneNumberLookup: "86BFD8F5-C55C-417C-B625-69AB84296637",
    /** The report search results block type */
    ReportSearchResults: "2DA8AA89-0DAA-4A50-B65B-CA721932B8A9",
    /** Group RSVP Detail Block instance. */
    RsvpDetail: "3A4B60BD-93D0-4447-9E1A-A7A5C183E52B",
    /** Group RSVP List Block instance. */
    RsvpList: "3EDD37F6-3E03-4CF4-B58F-95BEBB6E1938",
    /** Group RSVP Response Block instance. */
    RsvpResponse: "CA9DE522-DC29-45DE-8A86-C53AF02FA68C",
    /** The Step Flow block */
    StepFlow: "A40684E9-10DA-4CF8-815B-EBDE53624419",
    /** Communications/System Communication Categories Block instance. */
    SystemCommunicationCategories: "550D7229-2788-4C0E-BFE6-4AAE95D28267",
    /** System Communication Detail Block instance. */
    SystemCommunicationDetail: "E65EDFE8-5FE9-4785-9E3D-E5D4F6829819",
    /** System Communications List Block instance. */
    SystemCommunicationList: "CD18ECBD-A7FB-4167-9054-542362F87DC7",
    /** The workflow configuration change log notes block */
    WorkflowConfigurationChangeLogNotes: "2194F555-1261-4D23-B5E0-F19380DFB10A",
};
